import React from "react";
import { Loader } from "@vibe/core";

const Spinner = ({ size = "small", className }: any) => {
  return <Loader className={className} size={size} color="primary" />;
};

export default Spinner;
